import { generateTableSlice } from "./sliceTable";

const sliceCompanyTable = generateTableSlice("company");

export const ActionsCompanyTable = sliceCompanyTable.actions;
export const ReducerCompanyTable = sliceCompanyTable.reducer;
